import { initComponent } from './core/init-component.js'

initComponent('.js-adaptive-shopify-video', snippet => {
  const toggle = snippet.querySelector('.js-adaptive-shopify-video-toggle')
  if (!toggle) return

  const playIcon = toggle.querySelector('.js-icon-play')
  const pauseIcon = toggle.querySelector('.js-icon-pause')

  const getVideo = () => {
    const videos = snippet.querySelectorAll('video')
    return [...videos].find(v => v.offsetParent !== null) || videos[0]
  }

  const updateIcons = playing => {
    playIcon.classList.toggle('hidden', playing)
    pauseIcon.classList.toggle('hidden', !playing)
  }

  toggle.addEventListener('click', () => {
    const video = getVideo()

    if (!video) return

    if (video.paused) {
      video.play()
      updateIcons(true)
    } else {
      video.pause()
      updateIcons(false)
    }
  })

  const video = getVideo()
  if (video) {
    video.addEventListener('play', () => updateIcons(true))
    video.addEventListener('pause', () => updateIcons(false))
  }

  return { unload() { } }
})
